import React from 'react';
import { AutoSizeCard } from './autoSizeCard';
import { ReactComponent as InfoIcon } from './../../../assets/icons/info.svg';
import styles from './statCard.module.css';
import { IconHeading } from './iconHeading';

/**
 * @param {Object} props
 * @param {Object} props.stats Stats
 * @param {boolean} [props.infoIcon=true] Show Info Icon
 * @param {JSX.Element|string} props.title Title
 */
export const StatCard = ({stats = {}, infoIcon = true, title = <></>}) => {

    return <AutoSizeCard
        className={styles.StatCard}
    >
        <IconHeading icon={infoIcon ? <InfoIcon /> : null}>
            {title}
        </IconHeading>

        <div className={styles.Stats}>
        {
            Object.entries(stats).map(([key, stat]) => (
                <div key={key} className={styles.Stat}>
                    <div className={styles.StatLabel}>{key}</div>
                    <div className={styles.StatValue}>{stat}</div>
                </div>
            ))
        }
        </div>
    </AutoSizeCard>
}